import { render, staticRenderFns } from "./InputFormDataForm.vue?vue&type=template&id=0782faae&"
import script from "./InputFormDataForm.vue?vue&type=script&lang=js&"
export * from "./InputFormDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports